import '@ok/okd/fonts/iconfont-OKDS.css';
import './index.less';

document.addEventListener('DOMContentLoaded', () => {
  const activeMenuItem = document.querySelector(
    `.left-menu-list a[href="${window.location.pathname}"]`
  );
  activeMenuItem?.parentElement?.classList.add('active');

  const menuLabel = document.querySelector('.left-menu-title-sm');
  if (menuLabel) {
    menuLabel.addEventListener('click', () => {
      const leftMenu = document.querySelector('.left-menu-box');
      if (leftMenu.classList.contains('menu-open')) {
        document.body.style.overflow = 'auto';
      } else {
        document.body.style.overflow = 'hidden';
      }
      leftMenu.classList.toggle('menu-open');
    });
  }
});
